import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Offers from "@/components/site/Offers";
import ResourcesPreview from "@/components/site/ResourcesPreview";
import LeadForms from "@/components/site/LeadForms";
import Footer from "@/components/site/Footer";
import { usePageMeta } from "@/lib/seo";

export default function Landing() {
  usePageMeta(null, "ASAP Technologies et Reqen s'associent pour proposer des offres packagées autour de l'Agilité : diagnostic, processus, exigences, conformité et formations certifiantes.");
  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Offers />
      <ResourcesPreview />
      <LeadForms />
      <Footer />
    </main>
  );
}
